import React, { useState } from 'react';
import { Button, Text } from '@asigna/kit';
import { IInputFieldProps, InputField } from 'components';

interface StepOneProps {
  safeName: string;
  setSafeName: (safeName: string) => void;
  onNextClick: () => void;
  onBackClick: () => void;
}

const safeNameRegex = /^[A-Za-z0-9_-]+$/;

export const StepOne: React.FC<StepOneProps> = ({
  safeName,
  setSafeName,
  onNextClick,
  onBackClick,
}) => {
  const [safeNameError, setSafeNameError] = useState('');

  const handleInputChange: IInputFieldProps['onChange'] = (e) => {
    const value = e.target.value;
    setSafeName(value);
    if (!safeNameRegex.test(value) && value !== '') {
      setSafeNameError('Only alphanumeric characters and hyphens');

      return;
    }
    setSafeNameError('');
    if (value) {
      setSafeNameError('');
    }
  };

  return (
    <div className="flex flex-col gap-24 max-w-[592px] mx-auto">
      <Text
        message="Give a name to your vault. It cannot be changed after the vault is created"
        color="white"
        size="r20"
      />
      <div className="flex flex-col gap-24 rounded-[12px] border border-[.5px] border-black-4 bg-black-2 p-16 sm:p-24 mb-32">
        <div className="flex flex-col gap-8">
          <Text message="Vault name" size="m14" color="white" />
          <Text
            message="* Make sure the added owners, confirmation threshold of a new vault don't duplicate ones of the existing vault. Otherwise a new vault won't be created."
            color="orange"
            size="r12"
            className="mb-8"
          />
          <InputField
            value={safeName}
            placeHolder="Vault name"
            type="text"
            onChange={handleInputChange}
            errorInfo={safeNameError}
          />
        </div>
        <div className="flex gap-16 justify-end">
          <Button
            colorType="secondary"
            onClick={onBackClick}
            message="Cancel"
            className="w-[128px]"
          />
          <Button
            colorType="primary"
            onClick={onNextClick}
            disabled={!safeName || safeNameError.length > 0}
            message="Next"
            className="w-[128px]"
          />
        </div>
      </div>
    </div>
  );
};
